import type { components } from "@/api-schema";
import { VEHICLE_KIND_LABELS } from "@/common/helpers/vehicle-type-labels";

type ModelFamily = components["schemas"]["ModelFamily"];
type ModelGeneration = components["schemas"]["ModelGeneration"];

export function getModelFamilyMergeLabel(modelFamily: ModelFamily): string {
  return [modelFamily.name, modelFamily.brand?.name].filter(Boolean).join(" — ");
}

export function getModelGenerationMergeLabel(modelGeneration: ModelGeneration, language: string): string {
  const normalizedLanguage = language === "de" ? "de" : "en";
  const vehicleKind =
    VEHICLE_KIND_LABELS[modelGeneration.vehicleKind]?.[normalizedLanguage] ?? modelGeneration.vehicleKind;

  return [
    modelGeneration.name,
    vehicleKind,
    modelGeneration.modelFamily?.name,
    modelGeneration.modelFamily?.brand?.name,
  ]
    .filter(Boolean)
    .join(" — ");
}
